import React from 'react';
import {
	RouterProvider,
	createBrowserRouter,
	redirect,
} from 'react-router-dom';
import About from './components/About';
import MissionStatement from './components/About/MissionStatement';
import Services from './components/Services';
import ServiceAreaDetail from './components/Services/ServiceAreaDetail';
import ServiceAreas from './components/Services/ServiceAreas';
import ServiceDetail from './components/Services/ServiceDetail';
import CustomerList from './components/Admin/CustomerList';
import Crm from './components/Admin/Crm';
import Proposals from './components/Admin/Proposals';
import ProposalBuilder from './components/Admin/ProposalBuilder';
import Messages from './components/Admin/Messages';
import UserList from './components/Admin/UserList';
import Login from './components/Auth/Login';
import ProposalView from './components/ProposalView';
import BillUploadPage from './components/BillUploadPage';
import Contact from './components/Contact';
import Dashboard from './components/Dashboard';
import Landing from './components/Landing';
import { useUser } from './context/UserContext';
import MainLayout from './layout/MainLayout';
import Auth, { ACCESS_TOKEN_KEY } from './utils/auth';
import AdminLayout from './layout/AdminLayout';
import Me from './components/Me';
import Images from './components/Admin/Images';
import Logs from './components/Admin/Logs';
import WhyChooseGabe from './components/WhyChooseGabe';
import MarylandIncentives from './components/MarylandIncentives';
import AskGabe from './components/AskGabe';
import Utilities from './components/Utilities';
import UtilityDetail from './components/Utilities/UtilityDetail';
import Resources from './components/Resources';
import ResourceArticle from './components/Resources/ResourceArticle';
export default function Router() {
	const { user, isLoggedIn } = useUser();
	const routes = [
		{
			path: '/',
			element: <MainLayout />,

			children: [
				{ path: '/', element: <Landing /> },
				{
					path: 'login',
					element: user && isLoggedIn ? <Landing /> : <Login signup={false} />,
				},
				{ path: 'signup', element: <Login signup={true} /> },
				{ path: 'contact', element: <Contact /> },
				{ path: 'proposal/:id', element: <ProposalView /> },
				{ path: 'upload/:customerId/:token', element: <BillUploadPage /> },
				{ path: 'about', element: <About /> },
				{ path: 'services', element: <Services /> },
				{ path: 'services/:serviceId', element: <ServiceDetail /> },
				{ path: 'service-areas', element: <ServiceAreas /> },
				{ path: 'service-areas/:areaId', element: <ServiceAreaDetail /> },
				{ path: 'why-choose-gabe', element: <WhyChooseGabe /> },
				{ path: 'maryland-solar-incentives', element: <MarylandIncentives /> },
				{ path: 'ask-gabe', element: <AskGabe /> },
				{ path: 'solar-with', element: <Utilities /> },
				{ path: 'solar-with/:utilityId', element: <UtilityDetail /> },
				{ path: 'resources', element: <Resources /> },
				{ path: 'resources/:resourceId', element: <ResourceArticle /> },
				{ path: 'mission-statement', element: <MissionStatement /> },
				{ path: 'dashboard', element: <Dashboard /> },
				{ path: 'me', element: <Me /> },
			],
		},
		{
			path: '/admin',
			element: <AdminLayout />,
			loader: async () => {
				const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
				if (token) {
					const { user } = await Auth.getUser(token);
					if (!user) return redirect('/login');
					if (user && !user.isAdmin) return redirect('/');
					else if (user && user.isAdmin) return null; // allow through access
				}
				return redirect('/login');
			},
			children: [
				{ path: 'crm', element: <Crm /> },
				{ path: 'proposals', element: <Proposals /> },
				{ path: 'proposals/new', element: <ProposalBuilder /> },
				{ path: 'proposals/:id', element: <ProposalBuilder /> },
				{ path: 'customers', element: <CustomerList /> },
				{ path: 'messages', element: <Messages /> },
				{ path: 'users', element: <UserList /> },
				{ path: 'images', element: <Images /> },
				{ path: 'logs', element: <Logs /> },
			],
		},
	];
	const router = createBrowserRouter([...routes]);
	return <RouterProvider router={router} />;
}
